import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Headset, Lock, ShieldCheck, Tag } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import './WhyChooseUs.css';

const pledgeIcons = [ShieldCheck, Lock, Clock, Tag, Headset];

export default function WhyChooseUs() {
  const { t } = useLanguage();
  const w = t.whyChoose || {};
  const items = w.items || [];

  if (!items.length) return null;

  return (
    <section className="why-choose" id="why-choose">
      <div className="why-choose-inner">
        <header className="why-choose-head">
          <div>
            <span className="why-choose-kicker">{w.kicker}</span>
            <h2>{w.title}</h2>
          </div>
          <div className="why-choose-head-side">
            <p>{w.intro}</p>
            <Link to="/services" className="why-choose-cta">
              {w.cta}
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </div>
        </header>

        <ul className="why-choose-pledges" aria-label={w.commitmentsTitle}>
          {items.map((item, i) => {
            const Icon = pledgeIcons[i] || ShieldCheck;
            return (
              <li key={item.title} className="why-choose-pledge" style={{ '--pledge-i': i }}>
                <span className="why-choose-pledge-icon" aria-hidden="true">
                  <Icon size={22} strokeWidth={1.9} />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
